<template>
    <div
        class="header-root header-background"
        :class="{
            overlap: overlap === 'small',
            overlapLarge: overlap === 'large',
        }"
    >
        <div class="header-content">
            <h2 class="header inherit-color">{{ label }}</h2>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Header',
    props: {
        label: String,
        overlap: String, // Enums of 'small' or 'large'
    },
};
</script>

<style scoped>
.header-root {
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);
    height: 120px;
    position: relative;
    top: 0;
    left: 0;
    right: 0;
    overflow: hidden;
    z-index: -1;

    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
}
.overlap {
    padding-bottom: 26px;
    margin-bottom: -26px;
}
.overlapLarge {
    padding-bottom: 32px;
    margin-bottom: -32px;
}

.header {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-bottom: 4px;
}
.header-content {
    max-width: var(--grid-width);
    margin: auto;
    padding-top: 36px;
    padding-bottom: 24px;
    color: white;
}

@media only screen and (max-width: 1200px) {
    .header-content > h3 {
        padding-right: 12px;
        padding-left: 15px;
        font-size: 33px;
    }
    .header {
        font-size: 22px !important;
        padding-left: 20px;
    }
}
</style>

<style>
.header-background {
    /* background-image: url('https://i.imgur.com/2xerNyq.jpg') !important; */
}
.header-background::before {
    /* background: linear-gradient(to right, var(--primary), var(--primary)); */
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: 120px;
    left: 0;
    top: 0;
    z-index: -1;
    opacity: 0.86;
}
</style>
